import SendView from './views/SendView'
import AllMessagesView from './views/AllMessages'
import RecipientView from './views/Recipient'

export default [
  {
    path: '',
    name: 'voicemessage',
    component: SendView,
  },
  {
    path: 'sent',
    name: 'voicemessage-all',
    component: AllMessagesView,
  },
  {
    path: 'recipient',
    name: 'voicemessage-recipient',
    component: RecipientView,
  }
]

